import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			width: 16,
			height: 16,
			x: 0,
			y: 0,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h16v16H0V0z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#545F7E",
			clipPath: "url(#clip0_3840_154645)",
			children: [/* @__PURE__ */ _jsx("path", { d: "M14.805 13.883l-3.782-3.73a5.567 5.567 0 001.267-3.539C12.29 3.52 9.758 1 6.645 1 3.532 1 1 3.52 1 6.614c0 3.095 2.533 5.614 5.645 5.614a5.633 5.633 0 003.436-1.165l3.798 3.746a.657.657 0 00.928-.004.65.65 0 00-.004-.924l.002.002zm-8.16-2.96c-2.393 0-4.331-1.93-4.331-4.308s1.94-4.309 4.33-4.309c2.393 0 4.332 1.93 4.332 4.308 0 2.379-1.94 4.308-4.331 4.308v.001z" }), /* @__PURE__ */ _jsx("path", { d: "M8.824 5.961H7.302V4.447a.655.655 0 00-.657-.654.655.655 0 00-.657.654V5.96H4.466a.656.656 0 00-.657.653c0 .36.294.653.657.653h1.522v1.515c0 .36.295.653.657.653a.656.656 0 00.657-.653V7.267h1.522a.656.656 0 00.657-.653.656.656 0 00-.657-.653z" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3840_154645",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0H14V14H0z",
				transform: "translate(1 1)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgZoomIn);
export default ForwardRef;
